import { defineComponent } from 'vue'
import gForm from '@/components/g-form/g-form.vue'
import gDateInput from '@/components/g-date-input/g-date-input.vue'
import ComponenteController from "@/shared/controllers/componente/componenteController";
import gDataTable from '@/components/g-data-table/g-data-table.vue'
import { useToast } from 'primevue/usetoast'
import { required } from "@vuelidate/validators";
import AccountLoged from '@/shared/mixins/AccountLoged';
import GridParcelas from './components/GridParcelas.vue'
import DialogParcela from './components/DialogParcela.vue'

export default defineComponent({
  name: 'GerenciamentoAutomacao',

  components: {
    gForm,
    gDateInput,
    gDataTable,
    GridParcelas,
    DialogParcela
  },

  mixins:[AccountLoged],

  setup() {
    const toast = useToast()
    return { toast }
  },

  data() {
    return {
      OS: '',
      isSalvando: false,
      tipoFluxoSelecionado: null,
      tiposFluxo: [],
      loadingTiposFluxo: false,
      sentidoOnda: null,
      orcamentoId: null,
      numeroPedido: null,
      codigoExterno: '',
      produtoSelecionado: null,
      nomeProduto: null,
      produtos: [],
      dataCarregamento: '',
      quantidade: null,
      medidaFacaAbertaComprimento: null,
      medidaFacaAbertaLargura: null,
      descricao: '',
      termoPesquisa: '',
      popupComponente: false,
      popupSucesso: false,
      componentes: [],
      componentesProporcaoLabel: [],
      componenteSelecionado: null,
      componenteEncontrado: null,
      componentesSelecionados: [],
      componentesSelecionadosGrid: [],
      CapaInternaArray: [],
      PapelOndaArray: [],
      papelOnda: null,
      DescricaoCapaInterna: null,
      NumeroGramaturaPapelOnda: null,
      NumeroGramaturaCapaInterna: null,
      ObrigatoriedadePapelDeOndaComp: true,
      checkboxNovo: false,
      key: 0,
      // Campos específicos de IMPRESSÃO (CARTAO_IMPRESSO)
      codigoProdutoSuprema: null,
      produtoSupremaId: null,
      produtoSupremaNome: null,
      produtosSuprema: [],
      quantidadeTotalPedidoImpressao: null,
      quantidadeFolhasBaseCusto: null,
      parcelas: [],
      dialogParcelaVisible: false,
      parcelaEmEdicao: null,
      loading: false,
      buscarTimeout: null,
      colunas:  [
        { field: 'componenteProporcaoLabel', header: 'Componente' },
        { field: "numeroComponente", header: "Número"  },
        { field: "componenteTipoTexto", header: "Componentes" },
        { field: "ColunaMedidas", header: "Medidas"  },
        { field: "quantidadeCoresFrente", header: "Cor Frente"  },
        { field: "quantidadeCoresVerso", header: "Cor Verso"  },
        { field: "descricaoAcabamentoFrenteTexto", header: "Acabamento Frente" },
        { field: "descricaoAcabamentoVersoTexto", header: "Acabamento Verso"},
        { field: "descricaoMaterialTexto", header: "Material",  },
        { field: "descricaoCapaExternaTexto",header: "Capa Externa"},
        { field: "numeroGramaturaCapaExterna", header: "Gramatura" },
        { field: "descricaoPapelOndaTexto", header: "Papel Onda" },
        { field: "numeroGramaturaPapelOnda",header: "Gramatura" },
        { field: "descricaoCapaInternaTexto", header: "Capa Interna"},
        { field: "numeroGramaturaCapaInterna", header: "Gramatura"},
        { field: "descricaoOndaTexto", header: "Onda" },
        { field: "codigoSistema", header: "Sistema", width: "8%" },
      ],
      filtro: {
        'global': { value: null, matchMode: 'contains' },
        'componenteProporcaoLabel': { value: null, matchMode: 'contains' },
        'descricao': { value: null, matchMode: 'contains' }
      }
    }
  },

  watch: {
    numeroPedido(newVal) {
      if (newVal !== null) {
        const valor = newVal.toString()

        // Se ultrapassar 6 caracteres, mantém apenas os 6 primeiros
        if (valor.length > 6) {
          this.numeroPedido = parseInt(valor.slice(0, 6))
        }
        // Se for tipo CARTAO_IMPRESSO e número do pedido válido, buscar dados
        if (this.tipoFluxoSelecionado === 1 && valor.length >= 5) {
          // Debounce para evitar múltiplas chamadas
          clearTimeout(this.buscarTimeout)
          this.buscarTimeout = setTimeout(() => {
            this.buscarDadosPedidoSuprema()
          }, 500)
        }

        // Só buscar OS se for tipo FORMATO (0)
        if (this.tipoFluxoSelecionado === 0) {
          this.getOSPedidoBase(newVal)
        }


      }
    },
    termoPesquisa: {
      handler(newValue) {
        if (newValue) {
          this.buscarProdutos(newValue)
        }
      },
      debounce: 300
    },
    produtoSelecionado: {
      handler(newValue) {
        if (newValue) {
          this.buscarComponentes(newValue)
          this.componenteSelecionado = null
          this.componenteEncontrado = null
        } else {
          this.componentes = []
          this.componentesSelecionados = []
          this.componenteSelecionado = null
          this.componenteEncontrado = null
        }
      }
    },
    quantidadeTotalPedidoImpressao(newValue) {
      // Recalcular quantidade de CAIXAS de todas as parcelas quando quantidade total de caixas mudar
      // Necessário para fluxo CARTAO_IMPRESSO quando usuário alterar quantidade total
      if (newValue > 0 && this.parcelas && this.parcelas.length > 0) {
        // Usar função que distribui corretamente garantindo soma exata
        const parcelasDistribuidas = this.distribuirQuantidadeEntreParcelas(newValue, this.parcelas)

        this.parcelas = parcelasDistribuidas.map(parcela => {
          return {
            ...parcela,
            quantidadeCaixas: parcela.quantidadeCalculada
            // quantidadeCaixasSuprema permanece inalterado (é informativo)
          }
        })
      }
    },
    quantidadeFolhasBaseCusto(newValue) {
      // Recalcular quantidade de FOLHAS de todas as parcelas quando quantidade de folhas base custo mudar
      // Necessário para fluxo CARTAO_IMPRESSO quando usuário alterar quantidade de folhas
      if (newValue > 0 && this.parcelas && this.parcelas.length > 0) {
        // Usar função que distribui corretamente garantindo soma exata
        const parcelasDistribuidas = this.distribuirQuantidadeEntreParcelas(newValue, this.parcelas)

        this.parcelas = parcelasDistribuidas.map(parcela => {
          return {
            ...parcela,
            quantidadeFolhas: parcela.quantidadeCalculada
          }
        })
      }
    },
      truncarQuantidade(event) {
        const valor = event.value?.toString() ?? ''
        if (valor.length > 3) {
          // Mantém apenas os 3 primeiros dígitos
          const truncado = valor.substring(0, 3)
          this.quantidade = parseInt(truncado)
          this.$toast.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'Apenas 3 dígitos permitidos.',
            life: 3000
          })
        }
      }
  },
  async mounted () {
    if(!this.hasClaim('Gerenciamento-Automação')) {
      this.$router.push('/sem-acesso')
    }

    this.PapelOndaArray   = ComponenteController.getEnumDescricaoCapaPapelOnda().PapelOndaArray
    this.CapaInternaArray = ComponenteController.getEnumDescricaoCapaInterna().CapaInternaArray

    await this.carregarTiposFluxo()

  },
  methods: {
    /**
     * Distribui quantidade total entre parcelas baseado nos percentuais, garantindo que:
     * 1. Todos os valores são inteiros
     * 2. A soma é EXATAMENTE igual ao total (sem ultrapassar)
     * 3. Apenas parcelas COM parte decimal (vírgula) podem receber ajuste
     * 4. Entre essas, prioriza MENOR percentual primeiro
     * 5. Em caso de empate, prioriza a ÚLTIMA parcela
     *
     * Exemplos:
     * - Total: 1500, Parcelas: [37.5%, 37.5%, 25%] → [562, 563, 375]
     *   P1: 562.5 (tem decimal), P2: 562.5 (tem decimal), P3: 375.0 (SEM decimal)
     *   Resto=1: Só P1 e P2 podem receber. P2 (última) recebe +1
     *
     * - Total: 1575, Parcelas: [37.5%, 37.5%, 25%] → [590, 591, 394]
     *   P1: 590.625 (tem decimal), P2: 590.625 (tem decimal), P3: 393.75 (tem decimal)
     *   Resto=2: Todas podem receber. P3 (menor %) +1, P2 (última entre 37.5%) +1
     */
    distribuirQuantidadeEntreParcelas(total, parcelas) {
      if (!total || total <= 0 || !parcelas || parcelas.length === 0) {
        return parcelas
      }

      // Passo 1: Calcular quantidade e identificar quais têm parte decimal
      const parcelasComQuantidade = parcelas.map(parcela => {
        const percentual = parcela.percentualParcela || 0
        const quantidadeExata = (percentual / 100) * total
        const quantidadeCalculada = Math.floor(quantidadeExata)
        const temDecimal = quantidadeExata !== quantidadeCalculada // Verifica se tem vírgula
        return {
          ...parcela,
          quantidadeCalculada,
          temDecimal
        }
      })

      // Passo 2: Calcular o resto (diferença entre total e soma)
      const somaCalculada = parcelasComQuantidade.reduce((acc, p) => acc + p.quantidadeCalculada, 0)
      let resto = total - somaCalculada

      // Passo 3: Filtrar apenas parcelas que TÊM parte decimal (podem receber ajuste)
      const parcelasComDecimal = parcelasComQuantidade
        .map((p, index) => ({ ...p, indiceOriginal: index }))
        .filter(p => p.temDecimal)

      // Passo 4: Ordenar parcelas que podem receber ajuste:
      // - Prioridade 1: MENOR percentual primeiro
      // - Prioridade 2: Em empate, ÚLTIMA parcela primeiro
      const parcelasOrdenadas = parcelasComDecimal
        .sort((a, b) => {
          const diffPercentual = (a.percentualParcela || 0) - (b.percentualParcela || 0)
          if (diffPercentual !== 0) {
            return diffPercentual // MENOR percentual primeiro (crescente)
          }
          // Em caso de empate, maior índice primeiro (última parcela primeiro)
          return b.indiceOriginal - a.indiceOriginal
        })

      // Passo 5: Distribuir o resto apenas entre parcelas com decimal
      for (let i = 0; i < parcelasOrdenadas.length && resto > 0; i++) {
        const indice = parcelasOrdenadas[i].indiceOriginal
        parcelasComQuantidade[indice].quantidadeCalculada++
        resto--
      }

      // Passo 6: Retornar na ordem original (remover propriedades auxiliares)
      return parcelasComQuantidade.map(p => {
        // eslint-disable-next-line no-unused-vars
        const { temDecimal, ...parcelaLimpa } = p
        return parcelaLimpa
      })
    },

    async carregarTiposFluxo() {
      try {
        this.loadingTiposFluxo = true

        // Buscar tipos de fluxo do backend
        const response = await this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + 'tipos-fluxo'
        })

        // Code 200 = SUCESSO no enum CodeReturn
        if (response.data.code === 200 && response.data.data) {
          this.tiposFluxo = response.data.data
        } else {
          throw new Error('Resposta inválida da API')
        }

        // Definir tipo padrão (FORMATO = 0) se existir
        const tipoFormato = this.tiposFluxo.find(t => t.valor === 0)
        if (tipoFormato) {
          this.tipoFluxoSelecionado = tipoFormato.valor
        } else if (this.tiposFluxo.length > 0) {
          // Se não tiver FORMATO, usar o primeiro disponível
          this.tipoFluxoSelecionado = this.tiposFluxo[0].valor
        }

      } catch (error) {
        console.error('Erro ao carregar tipos de fluxo:', error)

        // Fallback para valores hardcoded se API falhar
        this.tiposFluxo = [
          { valor: 0, descricao: 'Formato' },
          { valor: 1, descricao: 'Venda de Chapa' }
        ]
        this.tipoFluxoSelecionado = 0

      } finally {
        this.loadingTiposFluxo = false
      }
    },

    /**
     * Formata data para enviar à API
     * Garante que null/undefined/string vazia vira null
     * Date vira ISO string
     * String dd/MM/yyyy vira ISO string
     */
    formatarDataParaAPI(data) {
      // Se for null, undefined ou string vazia, retorna null
      if (!data || data === '') {
        return null
      }

      // Se for Date, converte para ISO string
      if (data instanceof Date) {
        return data.toISOString()
      }

      // Se for string no formato dd/MM/yyyy, converte para ISO
      if (typeof data === 'string') {
        // Verifica se está no formato dd/MM/yyyy
        const formatoBrasileiro = /^(\d{2})\/(\d{2})\/(\d{4})$/
        const match = data.match(formatoBrasileiro)

        if (match) {
          const [, dia, mes, ano] = match
          // Cria Date e converte para ISO
          const dataObj = new Date(ano, mes - 1, dia)
          return dataObj.toISOString()
        }

        // Se já estiver em formato ISO ou outro formato válido, retorna como está
        return data
      }

      // Caso não seja nenhum dos anteriores, retorna null
      return null
    },
    onTipoFluxoChange() {
      // Limpar campos específicos quando trocar tipo
      this.limparCamposEspecificos()

      // Se há número de pedido preenchido, buscar dados específicos do novo tipo
      if (this.numeroPedido) {
        if (this.tipoFluxoSelecionado === 0) {
          // FORMATO - buscar OS
          this.getOSPedidoBase(this.numeroPedido)
        } else if (this.tipoFluxoSelecionado === 1) {
          // CARTAO_IMPRESSO - buscar dados completos do pedido Suprema
          clearTimeout(this.buscarTimeout)
          this.buscarTimeout = setTimeout(() => {
            this.buscarDadosPedidoSuprema()
          }, 500)
        }
      }
    },

    limparCamposEspecificos() {
      // Limpar campos específicos de cada tipo
      if (this.tipoFluxoSelecionado !== 0) { // Se não for FORMATO
        this.papelOnda = null
        this.NumeroGramaturaPapelOnda = null
        this.DescricaoCapaInterna = null
        this.NumeroGramaturaCapaInterna = null
        this.sentidoOnda = null
        this.medidaFacaAbertaComprimento = null
        this.medidaFacaAbertaLargura = null
      }

      if (this.tipoFluxoSelecionado !== 1) { // Se não for CARTAO_IMPRESSO
        this.codigoProdutoSuprema = null
        this.produtoSupremaId = null
        this.produtoSupremaNome = null
        this.produtosSuprema = []
        this.quantidadeTotalPedidoImpressao = null
        this.quantidadeFolhasBaseCusto = null
        this.parcelas = []
      }
    },

    async buscarProdutoSupremaVinculado(numeroPedido) {
      if (!numeroPedido) return

      try {
        const response = await this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `pedido-suprema/${numeroPedido}/produto`
        })

        // Code 200 = SUCESSO no enum CodeReturn
        if (response.data.code === 200 && response.data.data) {
          const { codigoProduto, produtoId, nomeProduto } = response.data.data

          // Preencher campos (READONLY - não editáveis)
          this.codigoProdutoSuprema = codigoProduto
          this.produtoSupremaId = produtoId
          this.produtoSupremaNome = nomeProduto

          // Criar item único para o dropdown (desabilitado)
          this.produtosSuprema = [{
            produtoId: produtoId,
            nomeProduto: `${codigoProduto} - ${nomeProduto}`
          }]


        } else {
          this.toast.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Produto não encontrado para o pedido informado',
            life: 3000
          })
        }
      } catch (error) {
        this.toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar produto do pedido Suprema',
          life: 3000
        })
      }
    },

    /**
     * Busca dados do componente do produto base Suprema
     * Preenche automaticamente medidas da faca, sentido da onda, papel da onda, gramatura e capa interna
     * SOMENTE para fluxo de Venda Impressão (Venda de Chapa)
     * @param {number} numeroPedido - Número do pedido Suprema
     */
    async buscarDadosComponenteSuprema(numeroPedido) {
      if (!numeroPedido) return

      // Validação extra: só buscar se for Venda Impressão
      if (this.tipoFluxoSelecionado !== 1) {
        console.log('Busca de dados do componente ignorada - não é fluxo de Venda Impressão')
        return
      }

      try {
        const response = await this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `pedido-suprema/${numeroPedido}/componente`
        })

        // Code 200 = SUCESSO no enum CodeReturn
        if (response.data.code === 200 && response.data.data) {
          const {
            medidaFacaAbertaLargura,
            medidaFacaAbertaComprimento,
            sentidoOnda,
            descricaoPapelOnda,
            numeroGramaturaPapelOnda,
            descricaoCapaInterna,
            numeroGramaturaCapaInterna
          } = response.data.data

          // Preencher campos automaticamente (serão enviados ao backend)
          this.medidaFacaAbertaLargura = medidaFacaAbertaLargura
          this.medidaFacaAbertaComprimento = medidaFacaAbertaComprimento
          this.sentidoOnda = sentidoOnda

          // Preencher campos de papel da onda e capa interna do produto base Suprema
          this.papelOnda = descricaoPapelOnda
          this.NumeroGramaturaPapelOnda = numeroGramaturaPapelOnda
          this.DescricaoCapaInterna = descricaoCapaInterna
          this.NumeroGramaturaCapaInterna = numeroGramaturaCapaInterna

          console.log('Dados do componente Suprema carregados (Venda Impressão):', {
            medidaFacaAbertaLargura,
            medidaFacaAbertaComprimento,
            sentidoOnda,
            descricaoPapelOnda,
            numeroGramaturaPapelOnda,
            descricaoCapaInterna,
            numeroGramaturaCapaInterna
          })
        } else {
          this.toast.add({
            severity: 'warn',
            summary: 'Aviso',
            detail: 'Dados do componente não encontrados para o pedido informado',
            life: 3000
          })
        }
      } catch (error) {
        console.error('Erro ao buscar dados do componente Suprema:', error)
        this.toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar dados do componente do pedido Suprema',
          life: 3000
        })
      }
    },

    /**
     * Busca dados completos do pedido Suprema incluindo parcelas
     * Método implementado na Tarefa 3.4
     * @param {number} numeroPedido - Número do pedido Suprema
     */
    async buscarDadosPedidoSuprema() {
      // Só buscar se for tipo CARTAO_IMPRESSO e tiver número do pedido
      if (!this.numeroPedido || this.tipoFluxoSelecionado !== 1) {
        return
      }

      try {
        this.loading = true

        // Chamar API para buscar dados completos do pedido
        const response = await this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `pedido-suprema/${this.numeroPedido}`
        })

        // Code 200 = SUCESSO no enum CodeReturn
        if (response.data.code !== 200 || !response.data.data) {
          this.toast.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Pedido não encontrado',
            life: 3000
          })
          return
        }

        const pedidoSuprema = response.data.data

        // Validar se possui sequência/lote (bloqueado)
        if (pedidoSuprema.possuiSequenciaLote) {
          this.toast.add({
            severity: 'error',
            summary: 'Pedido Bloqueado',
            detail: 'Este pedido pertence a uma sequência/lote e não pode ser automatizado',
            life: 5000
          })
          this.limparCamposImpressao()
          return
        }

        // 1. Buscar produto Suprema vinculado
        await this.buscarProdutoSupremaVinculado(this.numeroPedido)

        // 2. Buscar dados do componente Suprema SOMENTE se for Venda Impressão
        // Para outros fluxos, o usuário pode preencher manualmente se necessário
        if (this.tipoFluxoSelecionado === 1) { // 1 = CARTAO_IMPRESSO (Venda Impressão)
          await this.buscarDadosComponenteSuprema(this.numeroPedido)
        }

        // 3. Preencher outros campos automaticamente
        if (pedidoSuprema.quantidadeTotal) {
          //this.quantidadeTotalPedidoImpressao = pedidoSuprema.quantidadeTotal
          // Preencher também o campo quantidade (usado no formulário)
          this.quantidade = pedidoSuprema.quantidadeTotal
        }

        if (pedidoSuprema.dataPedido) {
          this.dataCarregamento = pedidoSuprema.dataPedido
        }

        // 3. Preencher parcelas se existirem
        if (pedidoSuprema.parcelas && pedidoSuprema.parcelas.length > 0) {
          // Primeiro: mapear parcelas com dados básicos (sem quantidades calculadas)
          const parcelasMapeadas = pedidoSuprema.parcelas.map(p => {
            // IMPORTANTE: Se dataCarregamentoSuprema não vier na parcela, usar a data do pedido
            const dataCarregamento = p.dataCarregamentoSuprema || p.dataCarregamento || pedidoSuprema.dataPedido

            // Percentual vem do backend calculado com base nas caixas do pedido Suprema:
            // (caixas parcela Suprema / total caixas Suprema) * 100
            const percentualParcela = p.percentualParcela || 0

            return {
              id: `parcela_${p.numeroParcela}_${Date.now()}`,
              numeroParcela: p.numeroParcela,
              quantidadeCaixasSuprema: p.quantidadeCaixas || 0, // Quantidade original do pedido Suprema (apenas informativo)
              quantidadeCaixas: 0, // Será calculado depois
              quantidadeFolhas: 0, // Será calculado depois
              dataCarregamentoSuprema: dataCarregamento,
              dataEntregaImpressaoJauense: p.dataEntregaImpressaoJauense,
              numeroOrdemServico: p.numeroOrdemServico || null,
              percentualParcela: percentualParcela,
              possuiDivergenciaData: this.verificarDivergenciaData(
                p.dataEntregaImpressaoJauense,
                dataCarregamento
              )
            }
          })

          // Segundo: distribuir CAIXAS corretamente garantindo soma exata
          let parcelasComCaixas = parcelasMapeadas
          if (this.quantidadeTotalPedidoImpressao > 0) {
            parcelasComCaixas = this.distribuirQuantidadeEntreParcelas(
              this.quantidadeTotalPedidoImpressao,
              parcelasMapeadas
            ).map(parcela => ({
              ...parcela,
              quantidadeCaixas: parcela.quantidadeCalculada || 0
            }))
          }

          // Terceiro: distribuir FOLHAS corretamente garantindo soma exata
          this.parcelas = parcelasComCaixas
          if (this.quantidadeFolhasBaseCusto > 0) {
            const parcelasComFolhas = this.distribuirQuantidadeEntreParcelas(
              this.quantidadeFolhasBaseCusto,
              parcelasComCaixas
            )

            this.parcelas = parcelasComFolhas.map((parcela, index) => ({
              ...parcelasComCaixas[index],
              quantidadeFolhas: parcela.quantidadeCalculada || 0
            }))
          } else {
            this.parcelas = parcelasComCaixas
          }

        }

      } catch (error) {
        console.error('Erro ao buscar dados do pedido Suprema:', error)
        console.error('Error response:', error.response)

        const errorMessage = error.response?.data?.message
          || error.response?.data?.detail
          || 'Erro ao buscar dados do pedido Suprema'

        this.toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: errorMessage,
          life: 5000
        })
      } finally {
        this.loading = false
      }
    },

    /**
     * Verifica se há divergência entre datas de entrega e carregamento
     * @param {Date|string} dataEntrega - Data de entrega Jauense
     * @param {Date|string} dataCarregamento - Data de carregamento Suprema
     * @returns {boolean} True se houver divergência
     */
    verificarDivergenciaData(dataEntrega, dataCarregamento) {
      if (!dataEntrega || !dataCarregamento) {
        return false
      }

      const dtEntrega = new Date(dataEntrega)
      const dtCarregamento = new Date(dataCarregamento)

      // Divergência = data entrega >= data carregamento
      return dtEntrega >= dtCarregamento
    },

    /**
     * Limpa apenas os campos específicos de impressão
     */
    limparCamposImpressao() {
      this.codigoProdutoSuprema = null
      this.produtoSupremaId = null
      this.produtoSupremaNome = null
      this.produtosSuprema = []
      this.quantidadeTotalPedidoImpressao = null
      this.quantidadeFolhasBaseCusto = null
      this.parcelas = []
    },

    validarTipoFluxoSelecionado() {
      if (this.tipoFluxoSelecionado === null || this.tipoFluxoSelecionado === undefined) {
        this.toast.add({
          severity: 'error',
          summary: 'Validação',
          detail: 'Selecione um tipo de fluxo antes de continuar',
          life: 3000
        })
        return false
      }
      return true
    },

    validarCamposFormato() {
      const erros = []

      if (!this.papelOnda) {
        erros.push('Papel de Onda é obrigatório')
      }

      if (!this.NumeroGramaturaPapelOnda) {
        erros.push('Gramatura da Onda é obrigatória')
      }

      if (!this.DescricaoCapaInterna) {
        erros.push('Capa Interna é obrigatória')
      }

      if (!this.NumeroGramaturaCapaInterna) {
        erros.push('Gramatura Capa Interna é obrigatória')
      }

      if (!this.medidaFacaAbertaComprimento) {
        erros.push('Medida Faca Aberta Comprimento é obrigatória')
      }

      if (!this.medidaFacaAbertaLargura) {
        erros.push('Medida Faca Aberta Largura é obrigatória')
      }

      if (!this.sentidoOnda) {
        erros.push('Sentido da Onda é obrigatório')
      }

      if (erros.length > 0) {
        this.toast.add({
          severity: 'error',
          summary: 'Validação',
          detail: erros.join(', '),
          life: 5000
        })
        return false
      }

      return true
    },

    validarCamposImpressao() {
      if (this.tipoFluxoSelecionado !== 1) return true

      const erros = []

      // Validações de campos básicos
      if (!this.codigoProdutoSuprema || !this.produtoSupremaId) {
        erros.push('Produto Suprema não foi identificado. Verifique o número do pedido.')
      }

      if (!this.quantidadeTotalPedidoImpressao || this.quantidadeTotalPedidoImpressao <= 0) {
        erros.push('Quantidade total do pedido de impressão é obrigatória')
      }

      if (!this.quantidadeFolhasBaseCusto || this.quantidadeFolhasBaseCusto <= 0) {
        erros.push('Quantidade de folhas base custo é obrigatória')
      }

      // VALIDAÇÕES DE PARCELAS
      if (this.parcelas.length === 0) {
        erros.push('É necessário adicionar pelo menos uma parcela')
      }

      if (erros.length > 0) {
        this.toast.add({
          severity: 'error',
          summary: 'Validação - Venda de Chapa',
          detail: erros.join(' | '),
          life: 8000
        })
        return false
      }

      return true
    },

    checkboxNovoAlterar() {
      this.checkboxNovo = !this.checkboxNovo
      if (this.checkboxNovo) {
        this.produtoSelecionado = null
      } else {
        this.nomeProduto = null
      }
      this.componentesSelecionadosGrid = []
      this.componentesSelecionados = []
      this.componentes = []
    },
    validarPedido() {
    if (this.numeroPedido == null) { 
      return this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'O campo de Número do pedido precisa ser preenchido', required, life: 5000 });
    } 
    return this.axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Pedido/ValidaPedidoByCodigoExterno/${this.numeroPedido}`
    })
    .then((response) => {
      if (response.data.data) {
        this.toast.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Pedido encontrado na base',
          life: 3000
        })
        return true;
      } else {
        this.toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Pedido não existe na base',
          life: 3000
        })
        return false;
      }
    })
    .catch(() => {
      this.toast.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Erro ao validar pedido',
        life: 3000
      })
      return false;
    });
  },
  buscarProdutos(campoPesquisa) {
    this.$isLoading(true)
    this.axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Produto/GetProdutoDropDownAutomacao/${campoPesquisa}`
    })
    .then((response) => {
      this.produtos = response.data.data
      this.$isLoading(false)
    })
    .catch(() => {
      this.produtos = []
      this.$isLoading(false)
    })
  },

  buscarComponentes(produtoId) {
    this.axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Componente/GetComponentesByProdutoId/${produtoId}`
    })
    .then((response) => {
      this.componentes = response.data.data
      this.componentesProporcaoLabel = this.componentes.map(componente => componente.componenteProporcaoLabel)
    })
    .catch(() => {
      this.componentes = []
      this.componentesProporcaoLabel = []
    })
  },

  buscarComponenteSelecionado() {
    if (this.componenteSelecionado !== null) {
      const componente = this.componentes.find(
        componente => componente.id === this.componenteSelecionado
      )
      if (componente) {
        // Armazena só os ids (GUIDs)
        this.componentesSelecionados = []
        this.componentesSelecionadosGrid = []
        this.componentesSelecionadosGrid.push(componente)
        this.componentesSelecionados.push(componente.id)
      }
      this.popupComponente = false
    }
  },

  adicionarComponente() {
    this.buscarComponenteSelecionado()
  },

  abrirPopupComponente() {
    this.popupComponente = true
  },

  removerComponente(componente) {
    this.componentesSelecionados = this.componentesSelecionados.filter(c => c.id !== componente.id)
  },
  /**
   * Salva automação de orçamento para fluxo FORMATO
   * Endpoint: POST /automacao-orcamento
   */
  salvarAutomacao () {
    this.isSalvando = true

    this.axios({
      method: 'post',
      url: process.env.VUE_APP_WEB_API + `automacao-orcamento`,
      data:{
      NomeProduto: this.nomeProduto,
      NumeroPedido: this.numeroPedido,
      MedidaFacaComprimento: this.medidaFacaAbertaComprimento,
      MedidaFacaLargura: this.medidaFacaAbertaLargura,
      Observacao: this.descricao,
      NovoProduto: this.checkboxNovo,
      DataCarregamento: this.dataCarregamento,
      Quantidade: this.quantidade,
      ProdutoId: this.produtoSelecionado,
      Componentes: this.componentesSelecionados,
      PapelOnda: this.papelOnda,
      CapaInterna: this.DescricaoCapaInterna,
      Gramatura: this.NumeroGramaturaPapelOnda,
      NumeroGramaturaCapaInterna: this.NumeroGramaturaCapaInterna,
      SentidoOnda: this.sentidoOnda,
      numeroOS: this.OS
      }
    })
    .then((response) => {
      if (response.data.data) {
        this.toast.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Orçamento FORMATO inserido com sucesso',
          life: 3000
        })
        this.orcamentoId = response.data.data
        this.limparVariaveis()
        this.getBuscarCodigoExterno()
      } else {
        this.toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao inserir o orçamento FORMATO',
          life: 3000
        })
      }
      this.isSalvando = false
    })
    .catch((error) => {
      console.error('Erro ao salvar automação FORMATO:', error)
      this.toast.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Erro ao inserir o orçamento FORMATO',
        life: 3000
      })
      this.isSalvando = false
      this.componentes = []
      this.componentesProporcaoLabel = []
    })
  },

  /**
   * Salva automação de orçamento para fluxo VENDA IMPRESSÃO (Venda de Chapa)
   * Endpoint: POST /automacao-orcamento-impressao
   * Inclui salvamento de parcelas
   */
  salvarAutomacaoImpressao () {
    this.isSalvando = true

    this.axios({
      method: 'post',
      url: process.env.VUE_APP_WEB_API + `automacao-orcamento-impressao`,
      data: {
        // Campos básicos
        NomeProduto: this.nomeProduto,
        NumeroPedido: this.numeroPedido,
        MedidaFacaComprimento: this.medidaFacaAbertaComprimento,
        MedidaFacaLargura: this.medidaFacaAbertaLargura,
        Observacao: this.descricao,
        NovoProduto: this.checkboxNovo,
        DataCarregamento: this.dataCarregamento,
        Quantidade: this.quantidade,
        ProdutoId: this.produtoSelecionado, // Produto selecionado para o orçamento

        // Campos de produto novo (se aplicável)
        Componentes: this.componentesSelecionados,
        PapelOnda: this.papelOnda,
        CapaInterna: this.DescricaoCapaInterna,
        Gramatura: this.NumeroGramaturaPapelOnda,
        NumeroGramaturaCapaInterna: this.NumeroGramaturaCapaInterna,
        SentidoOnda: this.sentidoOnda,

        // Campos específicos de IMPRESSÃO
        TipoFluxo: this.tipoFluxoSelecionado,
        CodigoProdutoSuprema: this.codigoProdutoSuprema,
        ProdutoSupremaId: this.produtoSupremaId,
        QuantidadeTotalPedidoImpressao: this.quantidadeTotalPedidoImpressao,
        QuantidadeFolhasBaseCusto: this.quantidadeFolhasBaseCusto,

        // PARCELAS - array de parcelas do grid
        Parcelas: this.parcelas.map(p => {
          const parcela = {
            NumeroParcela: p.numeroParcela,
            QuantidadeCaixas: p.quantidadeCaixas,
            QuantidadeFolhas: p.quantidadeFolhas
          }

          // Só adiciona as datas se tiverem valor válido
          const dataCarregamento = this.formatarDataParaAPI(p.dataCarregamentoSuprema)
          if (dataCarregamento) {
            parcela.DataCarregamentoSuprema = dataCarregamento
          }

          const dataEntrega = this.formatarDataParaAPI(p.dataEntregaImpressaoJauense)
          if (dataEntrega) {
            parcela.DataEntregaImpressaoJauense = dataEntrega
          }

          // Só adiciona OS se tiver valor
          if (p.numeroOrdemServico) {
            parcela.NumeroOrdemServico = p.numeroOrdemServico
          }

          // Só adiciona percentual se tiver valor
          if (p.percentualParcela) {
            parcela.PercentualParcela = p.percentualParcela
          }

          console.log('Parcela sendo enviada:', parcela)
          return parcela
        })
      }
    })
    .then((response) => {
      if (response.data.data) {
        this.toast.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Orçamento VENDA DE CHAPA inserido com sucesso',
          life: 3000
        })
        this.orcamentoId = response.data.data
        this.limparVariaveis()
        this.getBuscarCodigoExterno()
      } else {
        this.toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao inserir o orçamento VENDA DE CHAPA',
          life: 3000
        })
      }
      this.isSalvando = false
    })
    .catch((error) => {
      console.error('Erro ao salvar automação VENDA DE CHAPA:', error)

      const errorMessage = error.response?.data?.message
        || error.response?.data?.detail
        || 'Erro ao inserir o orçamento VENDA DE CHAPA'

      this.toast.add({
        severity: 'error',
        summary: 'Erro',
        detail: errorMessage,
        life: 5000
      })
      this.isSalvando = false
    })
  },
    async validations() {
      // Validar tipo de fluxo
      if (!this.validarTipoFluxoSelecionado()) {
        return
      }

      if (this.quantidade === 0 || this.quantidade == null) {
        return this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'O campo de Quantidade necessita de um valor', required, life: 5000 });
      }
      if (this.nomeProduto == null) {
        if (this.produtoSelecionado == null) { 
         return this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'O campo de Produto precisa ser selecionado', required, life: 5000 });
        }
      }
      if (this.produtoSelecionado == null) {
        if (this.nomeProduto == null) { 
          return this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'O campo de Produto precisa ser preenchido', required, life: 5000 });
        }
      }
      if (this.dataCarregamento == null || this.dataCarregamento == '') { 
        return this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'O campo de Data de carregamento precisa ser preenchido', required, life: 5000 });
      }
      if (this.quantidade == null) {
        return this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'O campo de Quantidade precisa ser preenchido', required, life: 5000 });
      }
      if (this.numeroPedido == null) {
        return this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'O campo de Número do pedido precisa ser preenchido', required, life: 5000 });
      } else {
        var pedido = await this.validarPedido()
        if (pedido === false) {
          return false;
        }
      }

      if(!this.parcelas.every(p => p.dataEntregaImpressaoJauense))
      {
        return this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'O campo de Data entrega Jauense precisa ser preenchido em todas as parcelas', required, life: 5000 });
      }
      return this.validationsGerais()
    },

    async validationsGerais() {
      // Validações específicas por tipo de fluxo
      if (this.tipoFluxoSelecionado === 0) { // FORMATO
        if (this.checkboxNovo === true) {
          // Novo produto tipo FORMATO - validar campos de formato
          if (!this.validarCamposFormato()) {
            return
          }
        } else {
          // Produto existente - validar componente
          if (this.componenteSelecionado == null) {
            return this.$toast.add({
              severity: 'error',
              summary: 'Erro ao preencher dados',
              detail: 'É necessário selecionar o componente',
              required,
              life: 5000
            })
          }
        }
      } else if (this.tipoFluxoSelecionado === 1) { // CARTAO_IMPRESSO
        // Validar campos de impressão
        if (!this.validarCamposImpressao()) {
          return
        }
      } else if (this.tipoFluxoSelecionado === 2) { // TERCEIRIZACAO
        // Validações para Terceirização serão implementadas nas próximas tarefas
        this.toast.add({
          severity: 'info',
          summary: 'Informação',
          detail: 'Validações específicas para Terceirização serão implementadas',
          life: 3000
        })
      }

      // Validação adicional de pedido se informado
      if (this.numeroPedido != null && this.numeroPedido != "") {
        var pedidoNovo = await this.validarPedido(this.numeroPedido)
        if (pedidoNovo === false) {
          return
        }
      }

      // Chamar função de salvamento correta baseado no tipo de fluxo
      if (this.tipoFluxoSelecionado === 0) {
        // FORMATO - chamar endpoint antigo
        return this.salvarAutomacao()
      } else if (this.tipoFluxoSelecionado === 1) {
        // CARTAO_IMPRESSO (VENDA IMPRESSÃO) - chamar novo endpoint
        return this.salvarAutomacaoImpressao()
      } else if (this.tipoFluxoSelecionado === 2) {
        // TERCEIRIZACAO - será implementado futuramente
        this.toast.add({
          severity: 'warn',
          summary: 'Não Implementado',
          detail: 'Salvamento de Terceirização ainda não foi implementado',
          life: 3000
        })
        return
      }
    },
     getBuscarCodigoExterno () {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `codigo-externo/${this.orcamentoId}`,
      })
      .then((response) => {
        if (response.data.data) {
          this.toast.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Código externo localizado',
            life: 3000
          })
          this.codigoExterno = response.data.data
          this.popupSucesso = true
        } else {
          this.toast.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao inserir o orçamento',
            life: 3000
          })
        }
      })
      .catch(() => {
        this.componentes = []
        this.componentesProporcaoLabel = []
    })
    },

    /**
     * Abre dialog para adicionar ou editar parcela
     * @param {Object|null} parcela - Dados da parcela para edição (null para nova)
     */
    abrirDialogParcela(parcela = null) {
      this.parcelaEmEdicao = parcela
      this.dialogParcelaVisible = true
    },

    /**
     * Salva parcela (nova ou editada) no array de parcelas
     * @param {Object} parcela - Dados da parcela a salvar
     */
    salvarParcela(parcela) {
      if (parcela.id) {
        // Edição de parcela existente
        const index = this.parcelas.findIndex(p => p.id === parcela.id)
        if (index !== -1) {
          this.parcelas.splice(index, 1, parcela)
        }
      } else {
        // Nova parcela
        parcela.id = this.gerarId()
        this.parcelas.push(parcela)
      }

      this.toast.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: parcela.id ? 'Parcela atualizada com sucesso' : 'Parcela adicionada com sucesso',
        life: 3000
      })

    },

    /**
     * Salva alteração de parcela editada inline (sem abrir diálogo)
     * @param {Object} parcela - Dados da parcela editada
     */
    salvarParcelaInline(parcela) {
      if (parcela.id) {
        // Edição de parcela existente
        const index = this.parcelas.findIndex(p => p.id === parcela.id)
        if (index !== -1) {
          this.parcelas.splice(index, 1, parcela)
        }
      }
    },

    /**
     * Exclui parcela do array
     * @param {Object} parcela - Dados da parcela a excluir
     */
    excluirParcela(parcela) {
      const index = this.parcelas.findIndex(p => p.id === parcela.id)
      if (index !== -1) {
        this.parcelas.splice(index, 1)
        this.toast.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Parcela excluída com sucesso',
          life: 3000
        })
      }
    },

    /**
     * Gera ID único para parcela
     * @returns {string} ID único
     */
    gerarId() {
      return `parcela_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    },

    limparVariaveis() {
        this.nomeProduto = null
        this.numeroPedido = ''
        this.medidaFacaAbertaComprimento = null
        this.medidaFacaAbertaLargura = null
        this.descricao = ''
        this.dataCarregamento = ''
        this.quantidade = null
        this.produtoSelecionado = null
        this.componentesSelecionados = []
        this.componentesSelecionadosGrid = []
        this.papelOnda = null
        this.DescricaoCapaInterna = null
        this.NumeroGramaturaPapelOnda = null
        this.NumeroGramaturaCapaInterna = null
        this.sentidoOnda = null
        // Limpar campos de IMPRESSÃO também
        this.codigoProdutoSuprema = null
        this.produtoSupremaId = null
        this.produtoSupremaNome = null
        this.produtosSuprema = []
        this.quantidadeTotalPedidoImpressao = null
        this.quantidadeFolhasBaseCusto = null
        this.parcelas = []
    },
    
    getOSPedidoBase(numeroPedido) {
    this.axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `numero-os-pedido-base-suprema/${numeroPedido}`
    })
    .then((response) => {
      this.OS = response.data.data
    })
    .catch(() => {
      this.produtos = []
      this.$isLoading(false)
    })
  },
  }
})
